export const CONFIGURATOR_NAVIGATION_RESET_EVENT = "configurator-v2:navigation-reset";

export const notifyConfiguratorNavigationReset = () => {
  window.dispatchEvent(new Event(CONFIGURATOR_NAVIGATION_RESET_EVENT));
};
